// Opt-in debug event surface for ble-core. When `requestSoluu` is called
// without a `debug` callback, every emit is a no-op. The web-app passes a
// callback that funnels events into its DiagnosticsProvider so a tester can
// see what the BLE layer is doing in real time without DevTools open.
export function nowMs() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return Math.round(performance.now());
    }
    return Date.now();
}
export function emit(listener, event) {
    if (!listener)
        return;
    try {
        listener(event);
    }
    catch {
        // A consumer's debug callback must not break the BLE layer.
    }
}
export function bytesToHex(view) {
    const bytes = view instanceof DataView
        ? new Uint8Array(view.buffer, view.byteOffset, view.byteLength)
        : view;
    let out = '';
    for (const b of bytes) {
        out += b.toString(16).padStart(2, '0');
    }
    return out;
}
export function describeError(cause) {
    if (cause instanceof Error)
        return cause.message;
    if (typeof cause === 'string')
        return cause;
    return String(cause);
}
//# sourceMappingURL=debug.js.map